import { Game } from '@Game/Game';
import { GameStore } from '@GameStore/GameStore';
import { GameScene } from '..';
import { EGameComponentHooks } from './GameComponentHooks';
import { GameComponentRegistry } from './GameComponentRegistry';

export interface IGameComponent {
    scene: GameScene;
    game: Game;
    gameStore: GameStore;
    [EGameComponentHooks.GameStoreInit](): void;
    [EGameComponentHooks.Init]?(): void;
    [EGameComponentHooks.Create]?(): void;
    [EGameComponentHooks.Destroy]?(): void;
}

export class GameComponent implements IGameComponent {
    public scene: GameScene;
    public game: Game;
    public gameStore: GameStore;
    constructor(scene: GameScene) {
        this.scene = scene;
        this.game = scene.game;
        GameComponentRegistry.register(scene, this);
    }

    onGameStoreInit(): void {
        this.gameStore = this.scene.game.gameStore;
    }

    onInit?(): void;
    onCreate?(): void;
    onDestroy?(): void;
}
